
import XHeader from 'vux/src/components/x-header/index.vue'
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'


export default {
components: {
XHeader,
VChart,
VTooltip,
VLine,
VScale
},
data () {
return {
chartData: [{
date: '2010-11-10',
value: 12.2
}]
};
},
created () {
this.loadData();
},
methods: {
loadData () {
const self = this;
self.$vux.loading.show({ text: 'Loading' });
self.$http.get('./static/phpapi/exchange.php', {params: {type: 'history'}})
.then((resp) => {
self.chartData = resp.data.obj.map((data) => {
return {
date: data[0],
value: parseFloat(data[2])
};
});
self.$refs.rateChart.rerender();
})
.catch((err) => console.error(err))
.then(() => self.$vux.loading.hide());
}
}
};



// WEBPACK FOOTER //
// ./src/components/exChange/RateHistory.vue